import MyDict from './dict.vue'
const Dict = {
  install: function (Vue) {
    Vue.component('Dict', MyDict)
  }
}
export default Dict

/**
 * 使用方法
 *  <Dict v-model="属性" :disabled="是否可读" dict="字典名称"></Dict>
 */
